<script>
import Sidebar from './Sidebar';
import UserReservations from './Reservations';
import UserProfile from './UserProfile';
import UserCompanies from './UserCompanies';
import ModifyEmail from './ModifyEmail';
import ModifyPassword from './ModifyPassword';
import { Form } from '../../helpers/Form/Form';

export default {
    name: "Profile",
    components: {
        Sidebar,
        UserReservations,
        UserProfile,
        ModifyEmail,
        ModifyPassword,
        UserCompanies
    },
    props: { 'userId': Number },
    data() {
        const form = new Form({
            id: this.userId,
            is_account: 1,
            email: '',
            new_email: '',
            phone: '',
            full_name: '',
            has_already_bought: 0,
            phonePrefix: '+39',
            password: '',
            password_confirmation: '',
            fiscal_file: {
                address: null,
                house_number: null,
                day: null,
                month: null,
                year: null,
                born: '',
                email: '',
                phone: '',
                phonePrefix: '+39',
                first_name: '',
                last_name: '',
                full_name: '',
                province: '',
                municipality: '',
                zip: '',
                fiscal_code: '',
                state: 'ITALIA',
                nationality: 'italian',
                accept_promotions: false
            }
        })

        return {
            userLoaded: false,
            form,
            companies: [],
            membercompany: {},
            members: [],
            companymembers: [],
            member: {},
            sidebarIndex: -1,
            modify: null,
            error: null,
            success: null,
            dismissSecs: 3,
            dismissCountDownError: 0,
            dismissCountDownSuccess: 0,
            courses: []
        }
    },
    mounted() {
        this.setSidebarIndex()
        this.fetchUser()

        window.onhashchange = () => {
            this.setSidebarIndex()
        }
    },
    methods: {
        fetchUser() {
            if (this.sidebarIndex === 1) {
                $("#spinner-modal").modal()
            }

            axios({
                method: 'get',
                url: '/users/' + this.form.id
            }).then((response) => {
                const user = response.data.user

                this.$set(this, 'companies', response.data.companies)
                this.$set(this, 'members', response.data.members)

                this.form.setAllData(user)

                if (user.first_name) {
                    this.$set(this.form.fiscal_file, 'first_name', user.first_name)
                }

                if (user.last_name) {
                    this.$set(this.form.fiscal_file, 'last_name', user.last_name)
                }

                if (user.full_name) {
                    this.$set(this.form.fiscal_file, 'full_name', user.full_name)
                }

                if (user.email) {
                    this.$set(this.form.fiscal_file, 'email', user.email)
                }

                if(user.phone) {
                    const pp = user.phone.split(" ")

                    if (pp.length === 2) {
                        this.$set(this.form, 'phonePrefix', pp[0])
                        this.$set(this.form.fiscal_file, 'phonePrefix', pp[0])
                        
                        this.$set(this.form, 'phone', pp[1])
                        this.$set(this.form.fiscal_file, 'phone', pp[1])
                    }
                } else {
                    this.$set(this.form, 'phonePrefix', "+39")
                    this.$set(this.form.fiscal_file, 'phonePrefix', "+39")
                }

                this.userLoaded = true
                
                if (this.sidebarIndex === 1) {
                    $("#spinner-modal").modal('hide')
                }
            }).catch((error) => {
                window.alerts.error('Errore caricando i dati')

                if (this.sidebarIndex === 1) {
                    $("#spinner-modal").modal('hide')
                }
            })
        },
        setSidebarIndex() {
            if (window.location.hash === '') {
                this.sidebarIndex = 1

                window.location.hash = '#account'

                this.resetData()
            }

            switch (window.location.hash) {
                case '#prenotazioni':
                    {
                        this.sidebarIndex = 0
                        this.resetData()
                    }
                break;
                case '#account':
                    {
                        this.sidebarIndex = 1

                        if (!this.userLoaded) {
                            this.fetchUser()
                        }

                        this.resetData()
                    }
                break;
                case '#company':
                    {
                        this.sidebarIndex = 2
                        this.resetData()
                    }
                break;
                case '#companies':
                    {
                        this.sidebarIndex = 3
                        this.resetData()
                    }
                break;
                case '#acquisti':
                    {
                        this.sidebarIndex = 4
                        this.resetData()
                    }
                break;
                default:
                    {
                        this.sidebarIndex = 5
                
                        const members = JSON.parse(JSON.stringify(this.members))

                        const hash_data = window.location.hash.split("-")
                        const page = hash_data[0]

                        if (hash_data.length > 1) {
                            const company_id = parseInt(hash_data[1], 10)

                            const companies = JSON.parse(JSON.stringify(this.companies))

                            const cmp = companies.filter((c) => {
                                return c.id === company_id
                            })

                            if (cmp.length > 0) {
                                this.$set(this, 'membercompany', cmp[0])
                            }

                            if (page === "#members") {
                                const cm = members.filter((m) => {
                                    return m.company_id === company_id
                                })

                                if (cm.length > 0) {
                                    this.$set(this, 'companymembers', cm)
                                }
                            } else if (page === "#member") {
                                if (hash_data.length > 2) {
                                    const member_id = parseInt(window.location.hash.split("-")[2], 10)

                                    const member = members.filter((m) => {
                                        return m.company_id === company_id && m.id === member_id
                                    })

                                    if (member.length > 0) {
                                        this.$set(this, 'member', member[0])
                                    }
                                }
                            }
                        }
                    }
                break;
            }
        },
        resetData() {
            this.$set(this, 'companymembers', [])
            this.$set(this, 'member', {})
            this.$set(this, 'membercompany', {})
        },
        goTo(index) {
            this.sidebarIndex = parseInt(index)
            return true
        },
        setModify(v) {
            window.location.hash = `#${v}`
            this.modify = v

            if (v !== 'email' && v !== 'password') {
                this.modify = null
            }
        },
        modifyEmail() {
            this.setModify('email')
        },
        modifyPassword() {
            this.setModify('password')
        },
        resetModify() {
            this.setModify('account')
        },
        initError(message) {
            window.alerts.error(message);
        },
        initSuccess(message) {
            window.alerts.success(message);
        },
        countDownErrorChanged(dismissCountDown) {
            this.dismissCountDownError = dismissCountDown
        },
        countDownSuccessChanged(dismissCountDown) {
            this.dismissCountDownSuccess = dismissCountDown
        },
        updateFormData({ data }) {
            this.form.setAllData(data)

            this.updateUser()
        },
        updateUser() {
            $("#spinner-modal").modal()

            this.form
                .submit('put', '/users/' + this.userId)
                .then(response => {
                    this.$set(this.form, 'password', '')
                    this.$set(this.form, 'password_confirmation', '')

                    window.alerts.success('Salvataggio dati avvenuto con successo');

                    $("#spinner-modal").modal('hide')
                })
                .catch(error => {
                    window.alerts.error('Attenzione completa i campi segnati in rosso prima di proseguire')

                    $("#spinner-modal").modal('hide')
                })
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/Profile.vue